import {Observable} from 'rxjs';
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ORIGIN_TYPE} from "../store/store-checkout/checkout.service";
import {HelperService} from "../helper.service";
import {WINDOW} from "../window-providers";
import {environment} from 'src/environments/environment';
import {IntegrationInitiatePaymentResponse, PaymentCompletedStatus, ReferenceType} from '../store/types/IntegrationPayment';
import { Order } from 'src/app/stores/stores';
import { PaymentOrderData } from './payment.types';


@Injectable({
  providedIn: 'root'
})
export class IntegrationPaymentService {

  constructor(private http: HttpClient,
              private helperService: HelperService,
              @Inject(WINDOW) private window: Window,
              ) {
  }

  initiatePayment(referenceType: ReferenceType, storeId: number, referenceId: string, data: any): Observable<IntegrationInitiatePaymentResponse> {
    let headers = new HttpHeaders();
    return this.http.post<any>(`api/v3/integration/stores/${storeId}/${ReferenceType[referenceType]}/${referenceId}/initiatePayment`, data, { headers });
  }

  fetchPaymentStatus(storeId: number, referenceId: string, params?: any): Observable<any> {
    return this.http.get<any>(`api/v3/integration/stores/${storeId}/${referenceId}/getPayment`, { params });
  }
  
  completePayment(storeId: number, paymentTransactionId: string, paymentCompletedStatus: PaymentCompletedStatus, data: any): Observable<any> {
    let headers = new HttpHeaders();
    return this.http.post<any>(`api/v3/integration/stores/${storeId}/${paymentTransactionId}/completePayment/${PaymentCompletedStatus[paymentCompletedStatus]}`, data, { headers });
  }

  getPaymentTransactionDetails(paymentReferenceValue: string): Observable<PaymentOrderData> {
    return this.http.get<PaymentOrderData>(`api/v3/integration/paymentTransaction/${paymentReferenceValue}`, {});
  }
}
